<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-form-item label="云平台名称" prop="name">
        <el-input v-model="initForm.name" placeholder="请输入云平台名称，不能重复添加"></el-input>
      </el-form-item>

      <el-form-item label="API地址" prop="api">
        <el-input v-model="initForm.api" placeholder="API地址"></el-input>
      </el-form-item>

      <el-form-item label="变更记录语种" prop="lang">
        <el-select v-model="initForm.lang" placeholder="选择变更记录语种">
        <el-option
          v-for="lang in deviceRomLangTypes"
          :label="lang"
          :key="lang"
          :value="lang"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="存储区域" prop="cloud">
        <el-select v-model="initForm.cloud" placeholder="选择存储区域">
        <el-option
          v-for="cloud in clouds"
          :label="cloud"
          :key="cloud"
          :value="cloud"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input v-model="initForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DeviceRomLangTypes } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    clouds: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{required: true, message: "请输入云平台名称", trigger: "blur"}],
        api: [{required: true, message: "请输入API地址", trigger: "blur"}],
        lang: [{required: true, message: "请输入变更记录语种", trigger: "blur"}],
        cloud: [{required: true, message: "请输入存储区域", trigger: "blur"}]
      },
      titles: {
        add: "新增软件包同步到对讲云的API",
        edit: "编辑软件包同步到对讲云的API"
      },
      deviceRomLangTypes: DeviceRomLangTypes
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              name: this.initForm.name,
              api: this.initForm.api,
              lang: DeviceRomLangTypes.indexOf(this.initForm.lang),
              cloud: this.initForm.cloud,
              remark: this.initForm.remark
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-rom/cloud-api/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-rom/cloud-api/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
